import type { IGroupSpaceResource } from "../../group-spaces";
import { createApiQueryHook, type IApiQueryFunction, type IPaginateable, mapPagination } from "../../utils/api";
import { mapRelationalFilter, type RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import type { IGroupMessageList } from "../types/IGroupMessageList";

export interface IGroupMessageListQueryParameters extends IPaginateable {
    filters?: {
        groupSpace?: RelationalFilter<IGroupSpaceResource>;
    };
}

export type IGroupMessageListQueryResult = IGroupMessageList;

const mapFilters = (filters: IGroupMessageListQueryParameters["filters"]) => {
    const { groupSpace } = filters ?? {};

    return {
        "groupSpace.uuid": mapRelationalFilter(groupSpace),
    };
};

export const groupMessageListQuery: IApiQueryFunction<IGroupMessageListQueryParameters> = ({
    pagination,
    filters,
}) => ({
    method: "GET",
    url: `/group_messages${serialize(
        {
            ...mapFilters(filters),
            ...mapPagination(pagination),
        },
        true,
    )}`,
});

export const useGroupMessageListQuery = createApiQueryHook<
    IGroupMessageListQueryParameters,
    IGroupMessageListQueryResult
>(groupMessageListQuery);
